import React from "react"
import Service from './obligations.service'
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import NumberFormat from "react-number-format"
import './obligations.styles.scss'
import { Link } from "react-router-dom/cjs/react-router-dom.min"

class Obligations extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadObligations()
        this.service.loadWallet()
    }

    onObligationSelected = obligation => {
        this.setState({
            ...this.state,
            selectedObligation: obligation,
            amount: obligation.amount,
            tab: 1
        })
    }

    onPay = () => {
        this.service.isValid() && this.service.processPayment()
    }

    renderCurrentTab() {
        switch (this.state.tab) {
            case 1:
                return this.renderPayNow()
            case 2:
                return this.renderSuccess()
            case 0:
            default:
                return this.renderObligationsList()
        }
    }

    renderObligationsList() {
        return (
            <>
                <div className="obligations-card">
                    <ul className="obligations-list">
                        {
                            this.state.obligations.map((obligation, key) => <li className="obligation-item">
                                <div className="item-details">
                                    <i className="fas fa-file-invoice icon-placeholder"></i>
                                    <div className="item-details-text">
                                        <p className="description">{obligation.name}</p>
                                        <p className="due-date">{obligation.type === 1 ? 'Reqiured' : 'Optional'}</p>
                                    </div>
                                </div>
                                <div className="item-action-group">
                                    <span className="amount">₦{<NumberFormat value={obligation.amount} displayType={'text'} thousandSeparator={true} renderText={value => value} />}</span>
                                    <button className="pay-button" onClick={() => this.onObligationSelected(obligation)}>
                                        Pay Now
                                    </button>
                                </div>
                            </li>)
                        }
                    </ul>
                </div>
                <div className="records">
                    {
                        this.state.loadingObligations === false && this.state.obligations.length === 0 && <h4>No Pending Obligations</h4>
                    }
                </div>
            </>
        )
    }

    renderPayNow() {
        return (
            <div className="payment-card">
                <div className="card-header">
                    <button className="pay-button" onclick={() => this.setState({ ...this.state, tab: 0 })}>
                    </button>
                    <h2 id="payment-title">{this.state.selectedObligation.name}</h2>
                </div>

                <div className="form-content">

                    <div className="wallet-info">
                        <div className="wallet-balance-group">
                            <span>Current Wallet Balance</span>
                            <p className="wallet-info-text">₦<NumberFormat value={this.state.wallet.balance} displayType={'text'} thousandSeparator={true} renderText={value => value} /></p>
                        </div>

                        <div className="fund-link-group">
                            <p id="balance-status"></p>
                            <div id="fund-wallet-link-container">
                                <Link to="/payment/wallet" className="fund-link">
                                    <i className="fas fa-wallet"></i> Fund Wallet Now
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Amount to Pay</label>
                        {this.state.selectedObligation.amountType === 1 ? <input type="text" name="amount" value={this.state.amount} onChange={(e) => this.setState({ ...this.state, amount: e.target.value })} disabled /> : <input type="text" name="amount" value={this.state.amount} onChange={(e) => this.setState({ ...this.state, amount: e.target.value })} />}
                        <span className="error">{this.state.errors.amount}</span>
                    </div>

                    <div className="form-group">
                        <label>Remarks (Optional)</label>
                        <input name="remarks" value={this.state.remarks} onChange={(e) => this.setState({ ...this.state, remarks: e.target.value })} />
                    </div>

                    {
                        this.state.wallet.balance >= Number(this.state.amount) ? <button id="final-pay-button" className="final-pay-button" onClick={this.onPay}>
                            Pay ₦{<NumberFormat value={this.state.amount} displayType={'text'} thousandSeparator={true} renderText={value => value} />}
                        </button> :
                            <button id="final-pay-button" className="final-pay-button" disabled>
                                Pay ₦{<NumberFormat value={this.state.amount} displayType={'text'} thousandSeparator={true} renderText={value => value} />}
                            </button>
                    }

                    <p className="note">
                        Note: Payments are processed instantly from your internal wallet balance.
                    </p>

                </div>
            </div>
        )
    }

    renderSuccess() {
        return (
            <div class="payment-card2">

                <div class="card-header">
                    <h2>
                        <i class="fas fa-check-circle"></i>
                        Payment Successful
                    </h2>
                </div>

                <div class="form-content">
                    <p>Amount Paid</p>
                    <h3>₦<NumberFormat value={this.state.amount} displayType={'text'} thousandSeparator={true} renderText={value => value} /></h3>

                    <div className="receipt">
                        <p className="bold">Item Paid For:</p>
                        <p className="description">{this.state.selectedObligation.name}</p>
                        <p className="bold">Transaction Reference:</p>
                        <p className="ref">{this.state.reference}</p>
                    </div>

                    <button class="final-pay-button" onClick={() => this.setState({ ...this.state, tab: 0, remarks: 0 })}>
                        Return to Obligations
                    </button>
                </div>
            </div>
        )
    }

    render() {
        return (
            <>
                {(this.state.loadingObligations || this.state.loadingWallet || this.state.processingPayment) && <Dialog><Loading /></Dialog>}
                <div className="obligations">
                    <div className="header">
                        <h1>Payment Obligations</h1>
                    </div>
                    {this.renderCurrentTab()}
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Obligations))